
import HeroRecipe from '@/components/article/HeroRecipe'
import Hero from '@/components/article/Hero'
import RelatedBlogPosts from '@/components/article/RelatedBlogPosts'
import WantToEatMorePlants from '@/components/article/WantToEatMorePlants'
import Sidebar from '@/components/article/Sidebar'
import RecipeCardComponent from '@/components/article/RecipeCard'
import ContentUpgradeComponent from '@/components/article/ContentUpgrade'
export default {
  name: 'BlogArticle',
  components: {
    ContentUpgradeComponent,
    RecipeCardComponent,
    Sidebar,
    WantToEatMorePlants,
    RelatedBlogPosts,
    Hero,
    HeroRecipe,
  },
  layout: 'noheader',
  async asyncData({ $axios, params, payload }) {
    if (payload) {
      return {
        wppost: payload,
      }
    } else if (params.id) {
      return await $axios
        .$get(
          `https://api.plantssogood.com/wp-json/wp/v2/posts/${params.id}?acf_format=standard`
        )
        .then((res) => {
          return {
            wppost: res,
          }
        })
    } else {
      return await $axios
        .$get(
          `https://api.plantssogood.com/wp-json/wp/v2/posts?slug=${params.slug}&acf_format=standard`
        )
        .then((res) => {
          if (res.length > 0) {
            return {
              wppost: res[0],
            }
          }
          return {
            wppost: {},
          }
        })
    }
  },
  data() {
    return {
      wppost: {},
    }
  },
  computed: {
    content() {
      return this.wppost?.content?.rendered
    },
    excerpt() {
      return this.wppost?.excerpt?.rendered?.replace(/(<([^>]+)>)/gi, '')
    },
    isRecipe() {
      try {
        return this.wppost?.acf?.recipe
      } catch (e) {
        return false
      }
    },
    baseURL() {
      return this.$config.baseURL
    },
    pinImage() {
      const acfData = this.wppost.acf
      if (
        acfData &&
        Object.prototype.hasOwnProperty.call(acfData, 'pinterest_pin_image')
      ) {
        return acfData.pinterest_pin_image !== false
          ? acfData.pinterest_pin_image.replace(
              'https://api.plantssogood.com',
              'https://ik.imagekit.io/rajumandapati/psg'
            )
          : this.wppost.featured_image_src.replace(
              'https://api.plantssogood.com',
              'https://ik.imagekit.io/rajumandapati/psg'
            )
      }
      return this.wppost.featured_image_src.replace(
        'https://api.plantssogood.com',
        'https://ik.imagekit.io/rajumandapati/psg'
      )
    },
    contentUpgrade() {
      try {
        if (this.wppost?.acf?.show_content_upgrade) {
          return {
            title: this.wppost.acf.content_upgrade_title,
            cta_text: this.wppost.acf.content_upgrade_cta_text,
            cta_url: this.wppost.acf.content_upgrade_cta_url,
          }
        }
        return null
      } catch (e) {
        console.log(e)
        return null
      }
    },
  },
}
